export enum CondicoesGerais {
  ADEQUADAS = 'ADEQUADAS',
  INADEQUADAS = 'INADEQUADAS',
}
